import { combineReducers } from 'redux';
import App from '@iso/redux/app/reducer';
import Auth from '@iso/redux/auth/reducer';
import ThemeSwitcher from '@iso/redux/themeSwitcher/reducer';
import LanguageSwitcher from '@iso/redux/languageSwitcher/reducer';
import Account from '@iso/redux/account/reducer';
import Common from '@iso/redux/common/reducer';
import User from '@iso/redux/users/reducer';
import Role from '@iso/redux/roles/reducer';
import Career from '@iso/redux/careers/reducer';
import SubcriptionPackage from '@iso/redux/subcriptionPackages/reducer';
import Learner from '@iso/redux/learners/reducer';
import Dashboard from '@iso/redux/dashboard/reducer';
import SubscriptionRequest from '@iso/redux/subscriptionRequests/reducer';
import FAQ from '@iso/redux/FAQs/reducer';
import Config from '@iso/redux/configs/reducer';

// SPEAKING
import ReadAloud from '@iso/redux/speaking/readAloud/reducer';
import DescribeImage from '@iso/redux/speaking/describeImage/reducer';
import AnswerShortQuestion from '@iso/redux/speaking/answerShortQuestion/reducer';
import RepeatSentence from '@iso/redux/speaking/repeatSentence/reducer';
import RetellLecture from '@iso/redux/speaking/retellLecture/reducer';

//LISTENING
import SummarizeSpokenText from '@iso/redux/listening/summarizeSpokenText/reducer';
import WriteFromDictation from '@iso/redux/listening/writeFromDictation/reducer';
import MultipleChoiceMultipleAnswer from '@iso/redux/listening/multipleChoiceMultipleAnswer/reducer';
import HighlightCorrectSummary from '@iso/redux/listening/highlightCorrectSummary/reducer';
import FillInTheBlanks from '@iso/redux/listening/fillInTheBlanks/reducer';
import MultipleChoiceSingleAnswer from '@iso/redux/listening/multipleChoiceSingleAnswer/reducer';
import SelectMissingWord from '@iso/redux/listening/selectMissingWord/reducer';
import HighlightInCorrectWord from '@iso/redux/listening/highlightInCorrectWord/reducer';

// WRITING
import SummarizeWrittenText from '@iso/redux/writing/summarizeWrittenText/reducer';
import WriteEssay from '@iso/redux/writing/writeEssay/reducer';
import BlanksDropDown from '@iso/redux/reading/fillInTheBlanksDropDown/reducer';
import BlanksDragDrop from '@iso/redux/reading/fillInTheBlanksDragDrop/reducer';
import ReOrderParagraph from '@iso/redux/reading/reOrderParagraph/reducer';
import MultipleAnswer from '@iso/redux/reading/multipleAnswer/reducer';
import SingleAnswer from '@iso/redux/reading/singleAnswer/reducer';

// MockTest
import MockTest from '@iso/redux/mockTest/reducer';
// QnA
import QnA from '@iso/redux/QnA/reducer';
export default combineReducers({
	Auth,
	App,
	ThemeSwitcher,
	LanguageSwitcher,
	Account,
	Common,
	User,
	Role,
	Career,
	SubcriptionPackage,
	Learner,
	Dashboard,
	SubscriptionRequest,
	FAQ,
	Config,
	// SPEAKING
	ReadAloud,
	DescribeImage,
	AnswerShortQuestion,
	RepeatSentence,
	RetellLecture,
	//LISTENING
	SummarizeSpokenText,
	WriteFromDictation,
	MultipleChoiceMultipleAnswer,
	MultipleChoiceSingleAnswer,
	HighlightCorrectSummary,
	FillInTheBlanks,
	SelectMissingWord,
	HighlightInCorrectWord,
	// WRITINNG
	SummarizeWrittenText,
	WriteEssay,
	BlanksDropDown,
	BlanksDragDrop,
	ReOrderParagraph,
	MultipleAnswer,
	SingleAnswer,
	//MockTest
	MockTest,
	//QnA
	QnA
});
